import React from 'react';

export default function newsletter() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <polygon fill="#fcb019" points="2.3 9.57 2.3 30.48 13.7 19.08 2.3 9.57"/>
      <polygon fill="#fcb019" points="36.55 8.33 3.45 8.33 20 22.13 36.55 8.33"/>
      <path fill="#fcb019" d="M20.54,23.88s-.01,0-.02.01c-.02.01-.03.02-.05.03-.03.02-.06.04-.1.06-.02,0-.04.02-.05.02-.04.02-.07.03-.11.04-.02,0-.03,0-.05.01-.05.01-.11.02-.16.02,0,0,0,0,0,0s0,0,0,0c-.05,0-.11,0-.16-.02-.02,0-.03,0-.05-.01-.04,0-.07-.02-.11-.04-.02,0-.04-.02-.05-.02-.03-.02-.07-.04-.1-.06-.02-.01-.03-.02-.05-.03,0,0-.01,0-.02-.01l-4.46-3.72L3.49,31.67h33.02l-11.51-11.51-4.46,3.72Z"/>
      <polygon fill="#fcb019" points="26.3 19.08 37.7 30.48 37.7 9.57 26.3 19.08"/>
    </svg>
  );
}
